module.exports = __webpack_public_path__ + "assets/img/symbol.7a03230d.svg";